module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag40_1920AT.88064972.jpg";